import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=bf401e98&"
import script from "./Payment.vue?vue&type=script&lang=js&"
export * from "./Payment.vue?vue&type=script&lang=js&"
import style0 from "./Payment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/builds/rentmagic/rentmagic.website.vue.west-vlaanderen/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BFormCheckbox, BCardText, BCard, BContainer} from 'bootstrap-vue'
    installComponents(component, {BFormCheckbox, BCardText, BCard, BContainer})
    

export default component.exports